import WhatsAppSipTrunksAPI from 'dashboard/api/whatsappSip/sipTrunks';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipTrunksAPI.get();
      const trunks = data.sip_trunks || data || [];
      commit('SET_RECORDS', trunks);
      return trunks;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipTrunksAPI.show(id);
    return data.sip_trunk || data;
  },

  async create({ commit }, trunkData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipTrunksAPI.create(trunkData);
      const trunk = data.sip_trunk || data;
      commit('ADD_RECORD', trunk);
      return trunk;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipTrunksAPI.update(id, updateData);
      const trunk = data.sip_trunk || data;
      commit('UPDATE_RECORD', trunk);
      return trunk;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipTrunksAPI.delete(id);
      commit('DELETE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async fetchSipCredentials(_, inboxId) {
    const { data } = await WhatsAppSipTrunksAPI.fetchSipCredentials(inboxId);
    return data;
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = Array.isArray(records) ? records : [];
  },

  ADD_RECORD($state, record) {
    const current = Array.isArray($state.records) ? $state.records : [];
    $state.records = [record, ...current];
  },

  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
